import { z } from 'zod';

export const skillSchema = z.object({
  name: z.string(),
  description: z.string().nullish(),
  descriptionEn: z.string().nullish(),
  emoji: z.string().nullish(),
  os: z.array(z.string()).default([]),
  requires: z.array(z.string()).default([]),
  homepage: z.string().nullish(),
  readme: z.string().nullish(),
  active: z.boolean().default(true),
  status: z.enum(['ok', 'warning']).default('ok'),
  warn: z.string().nullish(),
  skillsDir: z.string().nullish(),
  agents: z.array(z.string()).default([]),
});
export type Skill = z.infer<typeof skillSchema>;

export const skillsResponseSchema = z
  .object({
    skillsList: z.array(skillSchema).default([]),
  })
  .passthrough();
